import { IconButton } from "@circle-react-uikit/HeaderV3/IconButton";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { IconButton as CompassIconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { useAiSummaryContext } from "./Context";

interface AiSummaryContentProps {
  children: React.ReactNode;
  className?: string;
  closeButtonPosition?: "content" | "sidebar";
  rootClassName?: string;
}

export const AiSummaryContent = ({
  children,
  className,
  rootClassName = "",
  closeButtonPosition = "content",
}: AiSummaryContentProps) => {
  const { isCollapsed, onCollapseClick } = useAiSummaryContext();
  const { isCircleV4 } = useCircleV4();

  return (
    <div className={classNames("relative flex gap-3 min-w-0", rootClassName)}>
      <div
        className={classNames("flex grow flex-col gap-2 min-w-0", className)}
      >
        {children}
      </div>
      {!isCollapsed &&
        onCollapseClick &&
        (isCircleV4 ? (
          <CompassIconButton
            icon="cross"
            size="sm"
            variant="secondary"
            aria-label={t("collapse")}
            onClick={onCollapseClick}
            className={classNames({
              "absolute -right-0.5 -top-0.5": closeButtonPosition === "content",
            })}
          />
        ) : (
          <IconButton
            name="20-close"
            iconSize={20}
            onClick={onCollapseClick}
            variant="secondary"
            ariaLabel={t("collapse")}
            className={classNames(
              "bg-primary !border-primary !rounded-full border",
              {
                "absolute -right-0.5 -top-0.5":
                  closeButtonPosition === "content",
              },
            )}
          />
        ))}
    </div>
  );
};
